import {
	BellOutlined,
	UserSwitchOutlined,
	AppstoreAddOutlined,
	DashboardOutlined,
	SafetyCertificateOutlined,
} from "@ant-design/icons";
import qualityAssurance from "../services/qualityAssurance";
import QualityAssuranceForm from "../pages/qualityAssuranceForm/form";

const PageMeta = {
	dashboard: {
		title: "Dashboard",
		icon: <DashboardOutlined />,
	},

	RequestSupportForm: {
		title: "Service Request Form",
		icon: <AppstoreAddOutlined />,
	},

	requestSupportDesk: {
		title: "Request Support Desk",
		icon: <BellOutlined />,
	},

	qualityAssuranceForm: {
		title: "Quality Assurance Form",
		icon: <SafetyCertificateOutlined />,
	},

	assignTask: {
		title: "Assigned Tasks",
		icon: <UserSwitchOutlined />,
	},

	autoAssignTask: {
		title: "Auto Assign Task",
		icon: <UserSwitchOutlined />,
	},

	globalSearch: {
		title: "Global Search",
		icon: <AppstoreAddOutlined />,
	},

	requestDelete: {
		title: "Delete Request",
		icon: <AppstoreAddOutlined />,
	},
};

export default PageMeta;
